/*
A React wrapper for the init data fetch for atoms
Used currently in Next to init data within the main _app
*/
import React, { Fragment } from 'react';
import { useInitCoreAppState } from '../hooks/init';
import { useEffectOnce } from 'common-ui';
import { useRecoilCallback } from 'recoil';
import { notificationsAtom } from '../atoms/notificationsAtom';
import type { NotificationState } from '../atoms/notificationsAtom';
import { useAddToCartCustomEvent } from '../hooks/actions/cart/useCartCustomEvents';

export interface RecoilInitProps {
  children?: React.ReactNode;
}

const expirationCheckInterval = 100;

export const RecoilInit = ({ children }: RecoilInitProps) => {
  const initCoreAppState = useInitCoreAppState();
  const addToCartCustomEvent = useAddToCartCustomEvent();

  //Special case to update recoil state outside of react (so we can process notifications in the setInterval)
  //https://github.com/facebookexperimental/Recoil/issues/289
  //https://github.com/facebookexperimental/Recoil/issues/289
  const getRecoil = useRecoilCallback(
    ({ snapshot }) =>
      (atom: any) =>
        snapshot.getLoadable(atom).contents,
  );
  const setRecoil = useRecoilCallback(({ transact_UNSTABLE }) => (atom: any, valOrUpdater) => {
    transact_UNSTABLE(({ set }) => {
      set(atom, valOrUpdater);
    });
  });

  useEffectOnce(() => {
    initCoreAppState();

    setInterval(() => {
      const currentNotifications = getRecoil(notificationsAtom);
      const timeNow = Date.now();
      const updatedNotifications = currentNotifications.filter(
        (notification: NotificationState) => notification.expires > timeNow,
      );
      if (currentNotifications.length !== updatedNotifications.length) {
        setRecoil(notificationsAtom, updatedNotifications);
      }
    }, expirationCheckInterval);

    document.addEventListener('aws-add-to-cart', addToCartCustomEvent);

    return () => {
      document.removeEventListener('aws-add-to-cart', addToCartCustomEvent);
    };
  });
  return <Fragment> {children} </Fragment>;
};
